import * as React from "react";
import { InjectedFormProps, reduxForm, ConfigProps } from "redux-form";
import { ISearchParams } from "~/store/reducers/search/search-reducer";
import { ISearchResultsProps } from "../search-results";
import * as searchActions from "~/store/reducers/search/search-actions";
import Icon from "../../icons/icon";
import classNames from "classnames";
import FacetGroup from "../facet-group/facet-group";

interface IFacet {
    id: string;
    label: string;
    count: number;
}
export interface IFacetGroup {
    label: string;
    facets: IFacet[];
}

export interface IFacetFormProps {
    facetGroups?: IFacetGroup[];
    facetGroupsTitle?: string;
    facetGroupsConfirmButtonLabel?: string;
    facetsSeeMoreBtnLabel?: string;
    facetsSeeLessBtnLabel?: string;
}

export interface IFacetFormAllProps
    extends IFacetFormProps,
        Pick<ISearchParams, "facets">,
        Pick<ISearchResultsProps, "loadMoreWebApiUrl"> {
    isFacetModalOpen: boolean;
    closeFacetModal: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export interface IFacetFormData {}

type FacetFormPropsUnion = IFacetFormAllProps & InjectedFormProps<IFacetFormData, IFacetFormAllProps>;

const FacetForm: React.FC<FacetFormPropsUnion> = ({
    handleSubmit,
    facetGroups,
    facetsSeeMoreBtnLabel,
    facetsSeeLessBtnLabel,
    isFacetModalOpen,
    closeFacetModal,
    facetGroupsTitle,
    facetGroupsConfirmButtonLabel
}) => {
    const baseClass = "facet-form";
    const componentClasses = classNames(baseClass, {
        [`${baseClass}--facetModalOpen`]: isFacetModalOpen
    });

    return (
        <form className={componentClasses}>
            <button className={`${baseClass}__modal-close-btn button`} onClick={closeFacetModal}>
                <Icon iconId="icon_28_close" />
            </button>
            <h3 className={`${baseClass}__modal-title h2-style`}>{facetGroupsTitle}</h3>
            <div className={`${baseClass}__facets`}>
                {facetGroups?.map((group, i) => (
                    <FacetGroup
                        {...group}
                        seeLessLabel={facetsSeeLessBtnLabel}
                        seeMoreLabel={facetsSeeMoreBtnLabel}
                        handleSubmit={handleSubmit}
                        index={i}
                        key={i}
                    />
                ))}
            </div>
            <button className={`${baseClass}__modal-use-filter-btn button`} onClick={closeFacetModal}>
                {facetGroupsConfirmButtonLabel}
            </button>
        </form>
    );
};

const formConfig: ConfigProps<IFacetFormData, IFacetFormAllProps> = {
    form: "facetForm",
    onChange: (values, dispatch, props) => {
        const selectedFacets = [];

        for (const [key, value] of Object.entries(values)) {
            if (value === true) {
                selectedFacets.push(key);
            }
        }

        if (props.anyTouched) {
            dispatch(
                searchActions.searchRequest({
                    apiUrl: props.loadMoreWebApiUrl,
                    page: 0,
                    facets: selectedFacets
                })
            );
        }
    },
    touchOnChange: true
};

export default reduxForm<IFacetFormData, IFacetFormAllProps>(formConfig)(FacetForm);
